import { useEffect, useState } from 'react';

/** Live whole seconds until an ISO instant, ticking each second and clamped at 0; null when
 *  there is no instant to count to. Used for the newbie-grace lock, which lifts by the clock
 *  alone — the card re-enables itself at 0 with no refetch. */
export function useSecondsUntil(at: string | undefined): number | null {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!at) return;
    setNow(Date.now());
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, [at]);
  return botFillSeconds(at, now);
}

/** Whole seconds until the bot-fill deadline, clamped at 0. An absent or unparseable
 *  deadline → null (the global bot-fill toggle is off, so no countdown is shown). */
export function botFillSeconds(botFillAt: string | undefined, nowMs: number): number | null {
  if (!botFillAt) return null;
  const at = Date.parse(botFillAt);
  if (Number.isNaN(at)) return null;
  return Math.max(0, Math.ceil((at - nowMs) / 1000));
}
